var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if( form.items.length > 0 ){ 
__p+='\n<div class="survey-form js-survey-form-wrapper '+
((__t=( userIsGuest ? 'survey-form--disabled' : '' ))==null?'':_.escape(__t))+
'">\n  <div class="survey__items"></div>\n  <div class="survey__footer"></div>\n</div>\n';
 } 
__p+='\n';
}
return __p;
};
